import { ActivityFactory, ItineraryActivity } from "./activity.model";

export interface IItineraryDay {
    date: string;
    activities: ItineraryActivity[] | Partial<ItineraryActivity>[];
}

export class ItineraryDay implements IItineraryDay {
    date: string;
    activities: ItineraryActivity[] | Partial<ItineraryActivity>[];

    constructor(data?: IItineraryDay) {
        this.date = data?.date || '';
        this.activities = data?.activities.sort((a,b) => a.location < b.location ? -1 : 1).map(activity => ActivityFactory.create(activity)) || [];
    }
}